import { Button } from "@mui/material";
import { IButtons } from "./Types/Buttons.types";
import { getButtonSx, mergeSx } from "./buttonStyles";

export const ButtonPrimary = ({
  size = "sm",
  sx,
  sxButton,
  iconOnly,
  tooltip,
  ...props
}: IButtons) => (
  <Button
    {...props}
    sx={mergeSx((theme) => getButtonSx(theme, "primary", size), sx, sxButton)}
  />
);
